export default "__VITE_ASSET__a4b8d605__"